import { SvgIcon, type SvgIconProps } from './svgIcon'

export const ProjectsIcon = ({
  width = 18,
  height = 21,
  ...props
}: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox="0 0 18 21" {...props}>
    <path
      d="M0.834961 20.12H0.0849609V20.87H0.834961V20.12ZM0.834961 7.35L0.417704 6.72679L0.0849609 6.94957V7.35H0.834961ZM9.00496 1.88L9.42257 1.25703L9.00521 0.977256L8.5877 1.25679L9.00496 1.88ZM17.1649 7.35H17.9149V6.94984L17.5826 6.72703L17.1649 7.35ZM17.1649 20.12V20.87H17.9149V20.12H17.1649ZM1.58496 20.12V7.35H0.0849609V20.12H1.58496ZM1.25222 7.97322L9.42222 2.50322L8.5877 1.25679L0.417704 6.72679L1.25222 7.97322ZM8.58735 2.50298L16.7473 7.97298L17.5826 6.72703L9.42257 1.25703L8.58735 2.50298ZM16.4149 7.35V20.12H17.9149V7.35H16.4149ZM17.1649 19.37H0.834961V20.87H17.1649V19.37Z"
      fill="currentColor"
    />
  </SvgIcon>
)
